import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../../utils';
import theme from '../../../theme.style';

export default mergeStyleSets({
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
    paddingTop: pxToRem(20),
  },
  cancelButton: {
    backgroundColor: theme.palette.neutralWhite,
    color: theme.palette.themePrimary,
    border: pxToRem(0),
    paddingLeft: pxToRem(20),
    paddingRight: pxToRem(20),
  },
  dimensionPicker: {
    paddingLeft: pxToRem(20),
    paddingRight: pxToRem(20),
    paddingTop: pxToRem(10),
    paddingBottom: pxToRem(20),
    marginBottom: pxToRem(20),
    backgroundColor: theme.palette.neutralLighter,
  },
  errorBar: {
    paddingBottom: pxToRem(20),
  },
  errorRow: {
    background: 'red',
  },
  formActions: {
    float: 'right',
    paddingTop: pxToRem(20),
    paddingBottom: pxToRem(20),
  },
  loadingSpinner: {
    marginLeft: pxToRem(10),
  },
  note: {
    marginBottom: pxToRem(20),
    selectors: {
      '& .title': {
        fontWeight: 'bold',
        paddingBottom: pxToRem(5),
      },
    },
  },
  formFilters: {
    marginBottom: pxToRem(20),
  },
  formStyle: {
    paddingRight: pxToRem(24),
    marginTop: pxToRem(24),
    marginLeft: pxToRem(24),
    marginRight: pxToRem(24),
  },
});
